/* eslint-disable */
import Main from '../components/main';
export default [
  {
    name: "ExamShare",
    path: "/examShare",
    component: () => import('../view/examShare.vue'),
    meta: {
      title: "试卷分享",
      notInMain: true,
      breadcrumb: [
        {
          title: "试卷分享"
        }
      ]
    }
  },
  {
    name: "ForgetPwd",
    path: "/forgetPwd",
    component: () => import('../view/forgetPwd.vue'),
    meta: {
      notInMain: true,
      breadcrumb: []
    }
  },
  {
    name: "Login",
    path: "/login",
    component: () => import('../view/login.vue'),
    meta: {
      notInMain: true,
      breadcrumb: []
    }
  },
  {
    name: "Register",
    path: "/register",
    component: () => import('../view/register.vue'),
    meta: {
      notInMain: true,
      breadcrumb: []
    }
  },
  {
    path: "/",
    name: "_home",
    redirect: "/home",
    component: Main,
    children: [
      {
        name: "BusinessManagement",
        path: "businessManagement",
        component: () => import('../view/businessManagement/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "个人账户"
            }
          ],
          title: "个人账户"
        }
      },
      {
        name: "DayPractice",
        path: "dayPractice",
        component: () => import('../view/dayPractice/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "每日一练"
            }
          ],
          title: "每日一练"
        }
      },
      {
        name: "EShop",
        path: "eShop",
        component: () => import('../view/eShop/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "网上商城"
            }
          ],
          title: "网上商城"
        }
      },
      {
        name: "ExaminationBank",
        path: "examinationBank",
        component: () => import('../view/examinationBank/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "课程练习"
            }
          ],
          title: "课程练习"
        }
      },
      {
        name: "FaceCourse",
        path: "faceCourse",
        component: () => import('../view/faceCourse/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "面授课程"
            }
          ],
          title: "面授课程"
        }
      },
      {
        name: "Favorite",
        path: "favorite",
        component: () => import('../view/favorite/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "收藏夹"
            }
          ],
          title: "收藏夹"
        }
      },
      {
        name: "HistoricalRecord",
        path: "historicalRecord",
        component: () => import('../view/historicalRecord/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "积分管理"
            }
          ],
          title: "积分管理"
        }
      },
      {
        name: "LearningDatabase",
        path: "learningDatabase",
        component: () => import('../view/learningDatabase/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "课程下载"
            }
          ],
          title: "课程下载"
        }
      },
      {
        name: "MallOrders",
        path: "mallOrders",
        component: () => import('../view/mallOrders/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "商城订单"
            }
          ],
          title: "商城订单"
        }
      },
      {
        name: "MyExam",
        path: "myExam",
        component: () => import('../view/myExam/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "考试测评"
            }
          ],
          title: "考试测评"
        }
      },
      {
        name: "Newslist",
        path: "newslist",
        component: () => import('../view/newslist/index.vue')
      },
      {
        name: "NoticeList",
        path: "noticeList",
        component: () => import('../view/noticeList/index.vue')
      },
      {
        name: "PrepaidRecord",
        path: "prepaidRecord",
        component: () => import('../view/prepaidRecord/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "充值记录"
            }
          ],
          title: "充值记录"
        }
      },
      {
        name: "RecordingCourse",
        path: "recordingCourse",
        component: () => import('../view/recordingCourse/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "课程在线"
            }
          ],
          title: "课程在线"
        }
      },
      {
        name: "StatisticalLearning",
        path: "statisticalLearning",
        component: () => import('../view/statisticalLearning/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "帮助中心"
            }
          ],
          title: "帮助中心"
        }
      },
      {
        name: "TeacherList",
        path: "teacherList",
        component: () => import('../view/teacherList/index.vue')
      },
      {
        name: "Test",
        path: "test",
        component: () => import('../view/test/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "考试"
            }
          ],
          title: "考试"
        }
      },
      {
        name: "WithdrawalRecord",
        path: "withdrawalRecord",
        component: () => import('../view/withdrawalRecord/index.vue'),
        meta: {
          breadcrumb: [
            {
              title: "提现记录"
            }
          ],
          title: "提现记录"
        }
      },
      {
        name: "Example",
        path: "example",
        component: () => import('../view/example.vue')
      },
      {
        name: "ExamShareDetail",
        path: "examShareDetail",
        component: () => import('../view/examShareDetail.vue')
      },
      {
        name: "Home",
        path: "home",
        component: () => import('../view/home.vue'),
        meta: {
          title: "首页",
          breadcrumb: [
            {
              title: "首页"
            }
          ]
        }
      },
      {
        name: "Home1",
        path: "home1",
        component: () => import('../view/home1.vue')
      },
      {
        name: "Register1",
        path: "register1",
        component: () => import('../view/register1.vue')
      },
      {
        name: "BusinessManagementItem",
        path: "businessManagement/item",
        component: () => import('../view/businessManagement/item.vue')
      },
      {
        name: "BusinessManagementItem Copy",
        path: "businessManagement/item copy",
        component: () => import('../view/businessManagement/item copy.vue')
      },
      {
        name: "BusinessManagementMsgBoxList",
        path: "businessManagement/msgBoxList",
        component: () => import('../view/businessManagement/msgBoxList.vue')
      },
      {
        name: "DayPracticeAudioplay",
        path: "dayPractice/audioplay",
        component: () => import('../view/dayPractice/audioplay.vue')
      },
      {
        name: "DayPracticeCurrentt",
        path: "dayPractice/currentt",
        component: () => import('../view/dayPractice/currentt.vue')
      },
      {
        name: "DayPracticeExam2",
        path: "dayPractice/exam2",
        component: () => import('../view/dayPractice/exam2.vue')
      },
      {
        name: "DayPracticeList",
        path: "dayPractice/list",
        component: () => import('../view/dayPractice/list.vue')
      },
      {
        name: "DayPracticePaperLook",
        path: "dayPractice/paperLook",
        component: () => import('../view/dayPractice/paperLook.vue'),
        meta: {
          breadcrumb: [
            {
              title: "每日一练",
              to: "/dayPractice"
            },
            {
              title: "试卷解析"
            }
          ],
          title: "试卷解析"
        }
      },
      {
        name: "DayPracticePlaying",
        path: "dayPractice/playing",
        component: () => import('../view/dayPractice/playing.vue')
      },
      {
        name: "ExaminationBankCourseList",
        path: "examinationBank/courseList",
        component: () => import('../view/examinationBank/courseList.vue')
      },
      {
        name: "ExaminationBankErrorQuestion",
        path: "examinationBank/errorQuestion",
        component: () => import('../view/examinationBank/errorQuestion.vue'),
        meta: {
          breadcrumb: [
            {
              title: "试题库",
              to: "/examinationBank"
            },
            {
              title: "错题本"
            }
          ],
          title: "错题本"
        }
      },
      {
        name: "ExaminationBankHistoryDetail",
        path: "examinationBank/historyDetail",
        component: () => import('../view/examinationBank/historyDetail.vue'),
        meta: {
          breadcrumb: [
            {
              title: "试题库",
              to: "/examinationBank/paperLibraryExe"
            },
            {
              title: "成绩报告"
            }
          ],
          title: "成绩报告"
        }
      },
      {
        name: "ExaminationBankModel",
        path: "examinationBank/model",
        component: () => import('../view/examinationBank/model.vue')
      },
      {
        name: "ExaminationBankMyCourseList",
        path: "examinationBank/myCourseList",
        component: () => import('../view/examinationBank/myCourseList.vue')
      },
      {
        name: "ExaminationBankPaperLibrary",
        path: "examinationBank/paperLibrary",
        component: () => import('../view/examinationBank/paperLibrary.vue'),
        meta: {
          breadcrumb: [
            {
              title: "课程练习",
              to: "/examinationBank"
            },
            {
              title: "试卷库"
            }
          ],
          title: "试卷库"
        }
      },
      {
        name: "ExaminationBankPaperLibraryExe",
        path: "examinationBank/paperLibraryExe",
        component: () => import('../view/examinationBank/paperLibraryExe.vue'),
        meta: {
          breadcrumb: [
            {
              title: "试卷库",
              to: "/examinationBank/paperLibrary"
            },
            {
              title: "试卷"
            }
          ],
          title: "试卷"
        }
      },
      {
        name: "ExaminationBankPaperLibraryExes",
        path: "examinationBank/paperLibraryExes",
        component: () => import('../view/examinationBank/paperLibraryExes.vue'),
        meta: {
          breadcrumb: [
            {
              title: "试卷库",
              to: "/examinationBank/paperLibraryExe"
            },
            {
              title: "试卷练习"
            }
          ],
          title: "试卷练习"
        }
      },
      {
        name: "ExaminationBankPaperLooks",
        path: "examinationBank/paperLooks",
        component: () => import('../view/examinationBank/paperLooks.vue'),
        meta: {
          breadcrumb: [
            {
              title: "试题库",
              to: "/examinationBank/questionBank"
            },
            {
              title: "试卷解析"
            }
          ],
          title: "试卷解析"
        }
      },
      {
        name: "ExaminationBankProfile",
        path: "examinationBank/profile",
        component: () => import('../view/examinationBank/profile.vue')
      },
      {
        name: "ExaminationBankQuestionBank",
        path: "examinationBank/questionBank",
        component: () => import('../view/examinationBank/questionBank.vue'),
        meta: {
          breadcrumb: [
            {
              title: "课程练习",
              to: "/examinationBank"
            },
            {
              title: "试题库"
            }
          ],
          title: "试题库"
        }
      },
      {
        name: "ExaminationBankQuestionBankExe",
        path: "examinationBank/questionBankExe",
        component: () => import('../view/examinationBank/questionBankExe.vue'),
        meta: {
          breadcrumb: [
            {
              title: "试题库",
              to: "/examinationBank/questionBank"
            },
            {
              title: "习题库"
            }
          ],
          title: "习题库"
        }
      },
      {
        name: "ExaminationBankStudy",
        path: "examinationBank/study",
        component: () => import('../view/examinationBank/study.vue')
      },
      {
        name: "FaceCourseOfflinecourse",
        path: "faceCourse/offlinecourse",
        component: () => import('../view/faceCourse/offlinecourse.vue')
      },
      {
        name: "FaceCourseOnlinecourse",
        path: "faceCourse/onlinecourse",
        component: () => import('../view/faceCourse/onlinecourse.vue')
      },
      {
        name: "FaceCourseTeacherList",
        path: "faceCourse/teacherList",
        component: () => import('../view/faceCourse/teacherList.vue'),
        meta: {
          breadcrumb: [
            {
              title: "面授课程",
              to: "/faceCourse"
            },
            {
              title: "教师列表"
            }
          ],
          title: "教师列表"
        }
      },
      {
        name: "LearningDatabaseDetailModal",
        path: "learningDatabase/detailModal",
        component: () => import('../view/learningDatabase/detailModal.vue')
      },
      {
        name: "MyExamAudioplay",
        path: "myExam/audioplay",
        component: () => import('../view/myExam/audioplay.vue')
      },
      {
        name: "MyExamCurrentt",
        path: "myExam/currentt",
        component: () => import('../view/myExam/currentt.vue')
      },
      {
        name: "MyExamExam",
        path: "myExam/exam",
        component: () => import('../view/myExam/exam.vue'),
        meta: {
          breadcrumb: [
            {
              title: "考试测评",
              to: "/myExam"
            },
            {
              title: "考试中"
            }
          ],
          title: "考试中"
        }
      },
      {
        name: "MyExamExam1",
        path: "myExam/exam1",
        component: () => import('../view/myExam/exam1.vue')
      },
      {
        name: "MyExamExam2",
        path: "myExam/exam2",
        component: () => import('../view/myExam/exam2.vue')
      },
      {
        name: "MyExamHistory",
        path: "myExam/history",
        component: () => import('../view/myExam/history.vue'),
        meta: {
          breadcrumb: [
            {
              title: "考试测评",
              to: "/myExam"
            },
            {
              title: "历史考试"
            }
          ],
          title: "历史考试"
        }
      },
      {
        name: "MyExamHistoryDetail",
        path: "myExam/historyDetail",
        component: () => import('../view/myExam/historyDetail.vue'),
        meta: {
          breadcrumb: [
            {
              title: "历史考试",
              to: "/myExam"
            },
            {
              title: "查看"
            }
          ],
          title: "查看"
        }
      },
      {
        name: "MyExamPlaying",
        path: "myExam/playing",
        component: () => import('../view/myExam/playing.vue')
      },
      {
        name: "NewslistDetails",
        path: "newslist/details",
        component: () => import('../view/newslist/details.vue')
      },
      {
        name: "NoticeListDetails",
        path: "noticeList/details",
        component: () => import('../view/noticeList/details.vue')
      },
      {
        name: "RecordingCourseAllCourse",
        path: "recordingCourse/allCourse",
        component: () => import('../view/recordingCourse/allCourse.vue')
      },
      {
        name: "RecordingCourseCourseDetail",
        path: "recordingCourse/courseDetail",
        component: () => import('../view/recordingCourse/courseDetail.vue')
      },
      {
        name: "RecordingCourseCourseVideo",
        path: "recordingCourse/courseVideo",
        component: () => import('../view/recordingCourse/courseVideo.vue')
      },
      {
        name: "RecordingCourseMyCourse",
        path: "recordingCourse/myCourse",
        component: () => import('../view/recordingCourse/myCourse.vue')
      },
      {
        name: "StatisticalLearningDetails",
        path: "statisticalLearning/details",
        component: () => import('../view/statisticalLearning/details.vue')
      },
      {
        name: "TeacherListDetails",
        path: "teacherList/details",
        component: () => import('../view/teacherList/details.vue')
      },
      {
        name: "TestAnswerPage",
        path: "test/answerPage",
        component: () => import('../view/test/answerPage.vue'),
        meta: {
          breadcrumb: [
            {
              title: "考试",
              to: "/test"
            },
            {
              title: "答题"
            }
          ],
          title: "答题"
        }
      },
      {
        name: "TestAnswerResult",
        path: "test/answerResult",
        component: () => import('../view/test/answerResult.vue'),
        meta: {
          breadcrumb: [
            {
              title: "考试",
              to: "/test"
            },
            {
              title: "考试结果"
            }
          ],
          title: "考试结果"
        }
      }
    ]
  }
];